import * as _ from 'underscore'; //LL: 16.07.23: after OE's great changes in GIT
import * as $ from 'jquery';

import { validators as AppValidators } from '../../../../_common/application/ts/validators';

import { IDataQuery } from './Interfaces';

import { NONE } from '../../../../_common/platform/ts/ConfigurationConstants';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';

const NUMBERS_AND_LETTERS_REGEXP = /^(auto|0)$|^[+]?[0-9]+.?([0-9]+)?(px|em|ex|%|in|cm|mm|pt|pc)$/;

export var length = {
    pixel_percent: function (value) {
        if (!NUMBERS_AND_LETTERS_REGEXP.test(value)) {
            return ['Should contain positive numbers and letters'];
        }
    }
};

export function styles_namesUnique(value) {
    //LL: actually it is attrValue unique
    //LL: see CalendarMarkersField:
    //     attrValue ~~ name
    //  if (val === 'none') {
    //      delete obj.attrValue;
    //      obj.name = '';
    //}
    //  obj.name = fnd != null ? fnd.displayValue : '';

    //LL: unique for DataSource and EntityName
    let groups = _.groupBy<any>(value, (obj: any) => {
        //LL: allow repeate for "another" items ( = inherited from upper, ex Workspace)
        if (obj.another === true) return; // key === "undefined"

        //LL: unique for DataSource and EntityName
        let dataSourceID = obj.dataSourceID != null ? obj.dataSourceID : '';
        let entityName = obj.entityName != null ? obj.entityName : '';

        return dataSourceID.toString() + '_' + entityName;
    });
    let fnd = false;
    _.each(groups, (gr: any, key) => {
        //LL: allow repeate for "another" items ( = inherited from upper, ex Workspace)
        if (key === '_') return;

        let count = _.countBy<any>(gr, (obj: any) => {
            //LL: allow repeate for "another" items ( = inherited from upper, ex Workspace)
            if (obj.another === true) return; // key === "undefined"

            let name = obj.name;
            if (name != null) {
                name = $.trim(name);
            } else {
                name = ' ';
            }
            return name;
        });
        let find = _.find<any>(count, (num, key) => {
            if (key === 'undefined') return false;
            if (key === '') return false; //LL: for attrValue = null, i.e. 'none'
            return num > 1;
        });
        if (find != null) {
            fnd = true;
        }
    });

    if (fnd) {
        //return ['Attribute Values (except "none") must be different for all items of the same DataSource and Entity'];
        return ['Period Type Values (except "none") must be different'];
    }
}

//LL: for Calendars
export function getBackgroundGradient(pattern, colorPattern, lineWidth?, borderWidthActual?) {
    //let lineW2 = '2px';
    if (lineWidth == null) {
        lineWidth = 4;
    }
    // Math.round(3.5) = 4  Math.floor(3.5) = 3  ceil
    let lineW2 = Math.floor(lineWidth / 2) + 'px';

    //LL: for Vertical and Horizontal
    if (borderWidthActual == null) {
        borderWidthActual = 0;
    }
    borderWidthActual = Math.floor(borderWidthActual / 2);

    //let background = "linear-gradient(to bottom right,transparent calc(50% - " + lineW2 + "),red calc(50% - " + lineW2 + ") calc(50% + " + lineW2 + "), transparent calc(50% + " + lineW2 + ")), linear-gradient(to bottom left,transparent calc(50% - " + lineW2 + "),red calc(50% - " + lineW2 + ") calc(50% + " + lineW2 + "), transparent calc(50% + " + lineW2 + "))";
    let calcPlus = 'calc(50% + ' + lineW2 + ')';
    let calcMinus = 'calc(50% - ' + lineW2 + ')';
    //let background = "linear-gradient(to bottom right,transparent " + calcMinus + "," + colorPattern + " " + calcMinus + " " + calcPlus + ", transparent " + calcPlus + ")," +
    //    " linear-gradient(to bottom left,transparent " + calcMinus + "," + colorPattern + " " + calcMinus + " " + calcPlus + ", transparent " + calcPlus + ")";

    let diagonalRight =
        'linear-gradient(to bottom right,transparent ' +
        calcMinus +
        ',' +
        colorPattern +
        ' ' +
        calcMinus +
        ' ' +
        calcPlus +
        ', transparent ' +
        calcPlus +
        ')';
    let diagonalLeft =
        'linear-gradient(to bottom left,transparent ' +
        calcMinus +
        ',' +
        colorPattern +
        ' ' +
        calcMinus +
        ' ' +
        calcPlus +
        ', transparent ' +
        calcPlus +
        ')';

    let verticalLine =
        'linear-gradient(to right,transparent ' +
        calcMinus +
        ',' +
        colorPattern +
        ' ' +
        calcMinus +
        ' ' +
        calcPlus +
        ', transparent ' +
        calcPlus +
        ')';
    let horizontalLine =
        'linear-gradient(to bottom,transparent ' +
        calcMinus +
        ',' +
        colorPattern +
        ' ' +
        calcMinus +
        ' ' +
        calcPlus +
        ', transparent ' +
        calcPlus +
        ')';

    //LL: missing triangles for Diagonal lines:
    //  to bottom right:
    //  Bottom triangle is added when cell has right neighbour
    //  Top triangle is added when cell has left neighbour
    //  to bottom left:
    //  Bottom triangle is added when cell has left neighbour
    //  Top triangle is added when cell has right neighbour
    //let elem3 = $('.patternTriangleBottom');
    //elem3.css("background", "linear-gradient(to bottom right,transparent calc(100% - 6px),red calc(100% - 6px) calc(100% + 6px), transparent calc(100% + 6px)), cyan");
    //let elem4 = $('.patternTriangleTop');
    //elem4.css("background", "linear-gradient(to bottom right,transparent 0px,red 0px 6px, transparent 6px), cyan");

    let calcMinus_TriangleBottom = 'calc(100% - ' + lineW2 + ')';
    let calcPlus_TriangleBottom = 'calc(100% + ' + lineW2 + ')';
    let calcMinus_TriangleTop = '0px';
    let calcPlus_TriangleTop = lineW2;

    let diagonalRight_TriangleBottom =
        'linear-gradient(to bottom right,transparent ' +
        calcMinus_TriangleBottom +
        ',' +
        colorPattern +
        ' ' +
        calcMinus_TriangleBottom +
        ' ' +
        calcPlus_TriangleBottom +
        ', ' +
        'transparent ' +
        calcPlus_TriangleBottom +
        ')';
    let diagonalRight_TriangleTop =
        'linear-gradient(to bottom right,transparent ' +
        calcMinus_TriangleTop +
        ',' +
        colorPattern +
        ' ' +
        calcMinus_TriangleTop +
        ' ' +
        calcPlus_TriangleTop +
        ', ' +
        'transparent ' +
        calcPlus_TriangleTop +
        ')';

    let diagonalLeft_TriangleBottom =
        'linear-gradient(to bottom left,transparent ' +
        calcMinus_TriangleBottom +
        ',' +
        colorPattern +
        ' ' +
        calcMinus_TriangleBottom +
        ' ' +
        calcPlus_TriangleBottom +
        ', ' +
        'transparent ' +
        calcPlus_TriangleBottom +
        ')';
    let diagonalLeft_TriangleTop =
        'linear-gradient(to bottom left,transparent ' +
        calcMinus_TriangleTop +
        ',' +
        colorPattern +
        ' ' +
        calcMinus_TriangleTop +
        ' ' +
        calcPlus_TriangleTop +
        ', ' +
        'transparent ' +
        calcPlus_TriangleTop +
        ')';

    let background = 'transparent';
    switch (pattern) {
        case 'DiagonalRight':
            background = diagonalRight;
            break;
        case 'DiagonalLeft':
            background = diagonalLeft;
            break;
        case 'Cross':
            background = diagonalRight + ', ' + diagonalLeft;
            break;
        case 'HorizontalLine':
            if (borderWidthActual != null && borderWidthActual !== 0) {
                calcPlus = 'calc(50% + ' + lineW2 + ' + ' + borderWidthActual + 'px)';
                calcMinus = 'calc(50% - ' + lineW2 + ' + ' + borderWidthActual + 'px)';
                horizontalLine =
                    'linear-gradient(to bottom,transparent ' +
                    calcMinus +
                    ',' +
                    colorPattern +
                    ' ' +
                    calcMinus +
                    ' ' +
                    calcPlus +
                    ', transparent ' +
                    calcPlus +
                    ')';
            }
            background = horizontalLine;
            break;
        case 'VerticalLine':
            if (borderWidthActual != null && borderWidthActual !== 0) {
                //if (nbObj.hasLeft && !nbObj.hasRight) {
                //    bg = Validators.getBackgroundGradient(pattern, patternColor, lineWidth, borderWidthActual);
                //}
                //if (!nbObj.hasLeft && nbObj.hasRight) {
                //    bg = Validators.getBackgroundGradient(pattern, patternColor, lineWidth, -borderWidthActual);
                //}
                calcPlus = 'calc(50% + ' + lineW2 + ' + ' + borderWidthActual + 'px)';
                calcMinus = 'calc(50% - ' + lineW2 + ' + ' + borderWidthActual + 'px)';
                verticalLine =
                    'linear-gradient(to right,transparent ' +
                    calcMinus +
                    ',' +
                    colorPattern +
                    ' ' +
                    calcMinus +
                    ' ' +
                    calcPlus +
                    ', transparent ' +
                    calcPlus +
                    ')';
            }
            background = verticalLine;
            break;
        //LL: internal:
        case 'DiagonalRight_TriangleBottom': // == Diagonal-to-Left
            if (borderWidthActual != null && borderWidthActual !== 0) {
                calcPlus_TriangleBottom = 'calc(100% + ' + lineW2 + ' - ' + borderWidthActual + 'px)';
                calcMinus_TriangleBottom = 'calc(100% - ' + lineW2 + ' - ' + borderWidthActual + 'px)';
                diagonalRight_TriangleBottom =
                    'linear-gradient(to bottom right,transparent ' +
                    calcMinus_TriangleBottom +
                    ',' +
                    colorPattern +
                    ' ' +
                    calcMinus_TriangleBottom +
                    ' ' +
                    calcPlus_TriangleBottom +
                    ', ' +
                    'transparent ' +
                    calcPlus_TriangleBottom +
                    ')';
            }
            background = diagonalRight_TriangleBottom;
            break;
        case 'DiagonalRight_TriangleTop': // == Diagonal-to-Left
            if (borderWidthActual != null && borderWidthActual !== 0) {
                calcMinus_TriangleTop = '0px';
                //calcPlus_TriangleTop = lineW2 + " - " + borderWidthActual + "px";
                calcPlus_TriangleTop = 'calc(' + lineW2 + ' + ' + borderWidthActual + 'px)';
                //let calcPlus_TriangleBottom = "calc(100% + " + lineW2 + ")";
                diagonalRight_TriangleTop =
                    'linear-gradient(to bottom right,transparent ' +
                    calcMinus_TriangleTop +
                    ',' +
                    colorPattern +
                    ' ' +
                    calcMinus_TriangleTop +
                    ' ' +
                    calcPlus_TriangleTop +
                    ', ' +
                    'transparent ' +
                    calcPlus_TriangleTop +
                    ')';
            }
            background = diagonalRight_TriangleTop;
            break;
        case 'DiagonalLeft_TriangleBottom':
            background = diagonalLeft_TriangleBottom;
            break;
        case 'DiagonalLeft_TriangleTop':
            background = diagonalLeft_TriangleTop;
            break;
    }

    return background;
}

function validateRole(roles: any, role, value: any, queryName, ret, onlyCount = false) {
    if (roles != null && roles[role] != null) {
        const attributeWithRole_Exists = _.some(value.attrQuery, (attr: any) => {
            return attr.role === role;
        });
        const attributeWithRole_Count: any = _.countBy(value.attrQuery, (attr: any) => {
            return attr.role === role ? 'pn' : 'no';
        });
        if (!attributeWithRole_Exists && !onlyCount) {
            ret.push('"' + roles[role] + '" role must be defined for ' + queryName);
        }
        if (attributeWithRole_Count.pn > 1) {
            ret.push('"' + roles[role] + '" role can be only one for ' + queryName);
        }
    }
}

export function validateRolesPar(DisplayValuesList: any, queryName) {
    return function (value: IDataQuery) {
        if (value != null) {
            let roles: any = DisplayValuesList;
            // see
            //private static DisplayValuesList_Periods = {
            //    'pdcStart': 'Period Start',
            //    'pdcEnd': 'Period End',
            //    'ShiftType': 'Period Type',
            //    'ShiftLabel': 'Period Label'
            //};

            const attrQueries = value.attrQuery;
            const numberOfAttributes = attrQueries != null ? attrQueries.length : 0;
            if (numberOfAttributes === 0) {
                return null;
            }

            let ret = [];

            validateRole(roles, 'ShiftType', value, queryName, ret);
            validateRole(roles, 'pdcStart', value, queryName, ret);
            validateRole(roles, 'pdcEnd', value, queryName, ret);
            validateRole(roles, 'ShiftLabel', value, queryName, ret, true); //LL: allow not-defined

            validateRole(roles, 'Month', value, queryName, ret);
            validateRole(roles, 'Summary', value, queryName, ret);

            validateRole(roles, 'HolidayName', value, queryName, ret, true); //LL: allow not-defined
            validateRole(roles, 'HolidayDate', value, queryName, ret);

            validateRole(roles, 'ShiftTypeT', value, queryName, ret);
            //validateRole(roles, 'ShiftLabelT', value, queryName, ret, true); //LL: allow not-defined ?
            validateRole(roles, 'ShiftLabelT', value, queryName, ret); //LL: required
            validateRole(roles, 'ShiftIdT', value, queryName, ret); //LL: 03.10.23 for PeriodTypes Query in Themes

            if (ret.length > 0) {
                return ret;
            }
        }

        return null;
    };
}

//LL: new Calendars   Not interesting, use validateRolesPar above  call commented in AttributesField
//export function validateRoles(value: IDataQuery) {
//    if (value != null) {
//        const attrQueries = value.attrQuery;
//        const numberOfAttributes = attrQueries != null ? attrQueries.length : 0;
//        if (numberOfAttributes === 0) {
//            return null;
//        }
//
//        let ret = [];
//
//        if (ret.length > 0) {
//            return ret;
//        }
//    }
//
//    return null;
//}

//LL: from Grid
export function validateGroupingAttributes(value: IDataQuery) {
    if (value != null) {
        const attrQueries = value.attrQuery;

        const numberOfAttributes = attrQueries != null ? attrQueries.length : 0;
        if (numberOfAttributes === 0) {
            return null;
        }

        if (value.endlessScrolling === true) {
            const attributeWithSortingExists = _.some(value.attrQuery, (attr) => {
                return attr.sort != null && attr.sort !== NONE;
            });

            if (!attributeWithSortingExists) {
                return ['When Endless Scrolling is on, at least one Attribute must be sorted'];
            }
        }

        return AppValidators.attributesParameterField.validateGroupingAttributes(value);
    }

    return null;
}

//LL: from Grid   call commented in AttributesField
//export function validateDataLimit(value: IDataQuery) {
//    if (value != null) {
//        if (value.endlessScrolling === true && value.limit < 100) {
//            return ['When Endless Scrolling is on, the amount of records to retch must be at least 100'];
//        } else {
//            return null;
//        }
//    }
//
//    return null;
//}

//LL: from Grid
export function fix(value: IDataQuery, widgetData: any, glob: IGlob): IDataQuery {
    if (value.endlessScrolling === true) {
        // if (value.limit < 100) {
        //     glob.AppActions.showNotification_Warning(
        //         'Erros in "' + (widgetData.name || '') + '" widget configuration.<br/><br/>\n' +
        //         'When Endless Scrolling is on, the amount of rows to fetch must be equal or more than 100.<br/>\n' +
        //         'This parameter is changed to do not block widget execution.<br/>\n' +
        //         'Please, verify and fix widget configuration',
        //         null,
        //         {
        //             manualDestroy: true
        //         }
        //     );

        //     var newval = $.extend(
        //         true,
        //         {},
        //         value,
        //         {
        //             limit: 100
        //         }
        //     )

        //     return newval;

        // }

        let attributeWithSortingExists: boolean = _.some(value.attrQuery, (attr) => {
            return attr.sort != null && attr.sort !== NONE;
        });

        if (!attributeWithSortingExists) {
            glob.AppActions.showNotification_Fail(
                'Erros in "' +
                    (widgetData.name || '') +
                    '" widget configuration.<br/><br/>\n' +
                    'When Endless Scrolling is on, at least one Attribute must be sorted.<br/>\n' +
                    'The "EndlessScrolling" parameter is turned OFF in configuration to do not block widget execution.<br/>\n' +
                    'Please, verify and fix widget configuration',
                null
            );

            return $.extend(true, value, {
                endlessScrolling: false
            });
        } else {
            return value;
        }
    } else {
        return value;
    }
}

